import { getData, postData } from '../../utils/http'
import { setToken } from '@/utils/user'
export default {
	namespaced: true,
	state: {
		//信息
		userName: '',
		addLoading: false,
		//用户信息
		userInfo: null
	},
	mutations: {
		//写入用户登录数据
		SET_USER_LOGIN_INFO(state, data) {
			setToken(data)
		},
		//退出登录
		LOGINOUT(state) {
			localStorage.clear()
			sessionStorage.clear()
			window.location.reload(true)
		},
		CHANGE_ADD_LOADING(state, value) {
			state.addLoading = value
		}
	},
	actions: {
		//登陆
		userLogin({ commit }, loginData) {
			return new Promise(async resolve => {
				postData('auth/login', loginData).then(res => {
					if (res.state == 1) {
						commit('SET_USER_LOGIN_INFO', res.data)
						resolve({
							state: 1,
							msg: '登录成功'
						})
					} else {
						resolve({
							state: 0,
							msg: res.msg
						})
					}
				})
			})
		},

		//获取用户信息
		getCode({ commit }) {
			return new Promise(resolve => {
				getData('auth/code').then(res => {
					if (res.state == 1) {
						resolve({
							state: 1,
							msg: '成功',
							data: res.data
						})
					} else {
						resolve({
							state: 0,
							msg: res.msg
						})
					}
				})
			})
		},

		//退出登录
		loginOut({ commit, state }) {
			commit('LOGINOUT')
		},

		//修改密码
		editUserPwd({ commit }, data) {
			return new Promise(resolve => {
				postData(data.url, data.query).then(res => {
					if (res.state == 1) {
						resolve({
							state: 1,
							msg: '操作成功'
						})
					} else {
						resolve({
							state: 0,
							msg: res.msg
						})
					}
				})
			})
		},

		changeAddLoading({ commit }, value) {
			commit('CHANGE_ADD_LOADING', value)
		}
	}
}
